export default {
  email: '',
  password: '',
}
